export default ({ storageResolver }) => createStore => (
  reducer,
  preloadedState,
  enhancer
) => {
  const persistedState = storageResolver.load();
  const initialState = Object.assign({}, preloadedState, persistedState);
  return createStore(reducer, initialState, enhancer);
};



// WEBPACK FOOTER //
// ./src/store/persistentStateExtension.js